import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SelectComponent } from '@recruitee/user-interface';

import { DynamicHelpers } from '../../helpers';
import { DynamicSelectInputConfig, SelectOptionsT } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class SelectInput extends DynamicFormInput<DynamicSelectInputConfig> {
  public get hasSearch(): boolean {
    return !!this.config.hasSearch;
  }

  public get includeEmptyOption(): boolean {
    return !this.config.required;
  }

  public get iconEmptyLabel(): boolean {
    return !!this.config.iconEmptyLabel;
  }

  public isHidden(): boolean {
    return !this.config.required && !!this.config.hideIfEmpty && !this.config.options.length;
  }
}

@Component({
  selector: 'rti-dynamic-select-input',
  templateUrl: './dynamic-select-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent],
})
export class DynamicSelectInputComponent {
  @Input() public input: SelectInput;
  public options: SelectOptionsT = [];

  constructor(private helpers: DynamicHelpers) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('input' in changes) {
      this.buildOptions();
    }
  }

  private buildOptions(): void {
    this.options = this.helpers.buildOptions(this.input.config.options);
  }
}
